// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"134":"e059c57d","147":"c3cca2fc","299":"206a1836","601":"83b6d0fc","880":"10a0aeec"}[chunkId] + ".js";
};